<template>
	<div class="bg-white px-3 index" >
		<div class="add_tits" ref="title">
			<el-form class="form-inlines" :inline="true">
				<el-form-item label="日期:">
					<el-date-picker v-model="search.time" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" size='small' value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-printer" size="small" plain @click="openExportExcel">
					</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
			<el-tab-pane label="平台收入记录" name="1">
				<ptsrjl :times="search.time" ref="a" />
			</el-tab-pane>
			<el-tab-pane label="平台支出记录" name="2">
				<ptzcjl :times="search.time" ref="b" />
			</el-tab-pane>
			<el-tab-pane label="平台退款记录" name="3">
				<pttkjl :times="search.time" ref="c" />
			</el-tab-pane>
		</el-tabs>
		<!-- 导出 -->
		<el-dialog title="导出数据" :visible.sync="exportModal" center width="30%">
			<el-form :model="exportForm" ref="ruleForm" label-width="80px">
				<el-form-item label="时间范围" required>
					<el-date-picker size="small" v-model="exportForm.time" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="导出表" required>
					<el-select v-model="exportForm.tabname" placeholder="请选择" size="small">
						<el-option v-for="item in tabs_options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="exportModal = false">取 消</el-button>
				<el-button type="primary" :loading='exporloading' @click="exportExcel">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import buttonSearch from "@/components/common/button-search.vue"
	import ptsrjl from "./tabs/ptsrjl.vue";
	import pttkjl from "./tabs/pttkjl.vue";
	import ptzcjl from "./tabs/ptzcjl.vue";
	export default {
		components: {
			buttonSearch,
			ptsrjl,
			pttkjl,
			ptzcjl,
		},
		data() {
			return {
				tableData: [],
				currentPage: 1,
				multipleSelection: [],

				search: {
					time: [],
					keyword: ""
				},
				activeName: '1',
				exportModal: false,
				exportForm: {
					time: [],
					tabname:'1'
				},
				exporloading: false,
				tabs_options:[
					{label:'平台收入记录',value:'1'},
					{label:'平台支出记录',value:'2'},
					{label:'平台退款记录',value:'4'},
				]
			}
		},
		created() {},
		mounted() {
			this.begin()
		},
		methods: {
			begin() {
				// if (this.activeName == 1) {
					this.$refs.a.begin()
				// } else if (this.activeName == 2) {
					this.$refs.b.begin()
				// } else if (this.activeName == 3) {
					this.$refs.c.begin()
				// }
			},
			handleClick() {},
			openExportExcel() {
				this.exportModal = true
			},
			exportExcel() {
				if (this.exportForm.time.length == 0) return this.$message.error('请选择时间范围')
				let val = this.exportForm.time
				let params = ''
				if (val && Array.isArray(val)) {
					params += `&starttime=${val[0]}`
					params += `&endtime=${val[1]}`
				}
				let url = `/admin/pc/Excel/incomeExcel?type=${this.exportForm.tabname}`

				this.exporloading = true
				this.axios.post(url + params, {}, {
					token: true,
					responseType: 'blob'
				}).then(res => {
					if (res.status == 200) {
						this.exportModal = false
						let url = window.URL.createObjectURL(new Blob([res.data]))
						let link = document.createElement('a')
						link.style.display = 'none'
						link.href = url
						let filename = new Date().getTime() + '.xlsx';
						link.setAttribute('download', filename)
						document.body.appendChild(link)
						link.click()
					} else if (res.data.code != 200) {
						this.$message('暂无数据')
					}
					this.exporloading = false

				}).catch(err => {
					this.exporloading = false

				})
			}
		},
	}
</script>

<style>
	.sku-list-item>i {
		display: none;
		cursor: pointer;
	}

	.sku-list-item:hover {
		background-color: #f4f4f4;
	}

	.sku-list-item:hover>font {
		display: none;
	}

	.sku-list-item:hover>i {
		display: inline-block;
	}
</style>